import { render, staticRenderFns } from "./DocumentTaskTemplateActions.vue?vue&type=template&id=162b09a9&scoped=true&lang=pug"
import script from "./DocumentTaskTemplateActions.vue?vue&type=script&lang=ts"
export * from "./DocumentTaskTemplateActions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162b09a9",
  null
  
)

export default component.exports